import React from "react";

const NotFound = () => {
  return <div className="not-found">404</div>;
};

export default NotFound;
